import styled from "styled-components";

import { skeleton } from "components/shared/skeleton/Skeleton";

export const CurrentStatus = styled.div`
    color: var(--color-green);
    font-weight: 500;
    font-size: 16px;

    ${props =>
        props.closed &&
        `
        color: var(--color-red);
    `}
`;

export const InfoContainer = styled.div`
    margin-top: 15px;
`;

export const InfoTitle = styled.div`
    font-weight: 500;
    font-size: 16px;
`;

export const InfoContent = styled.div`
    margin-top: 5px;
`;

export const OpeningHoursRow = styled.div`
    text-transform: capitalize;
`;

export const Day = styled.div`
    display: inline-block;
    width: 70px;

    margin-right: 40px;
`;

export const Time = styled.div`
    display: inline-block;
`;

export const Skeleton = styled.div`
    width: 100%;
    height: 70px;

    ${skeleton("gray")}
`;
